import { ProductWithSavedStatus } from './types';

/**
 * 데이터에 is_saved_product 필드가 있는지 확인합니다.
 */
export function hasLikeStatusData<T>(data: T): data is T & ProductWithSavedStatus[] {
  return (
    Array.isArray(data) &&
    data.some(
      (item) =>
        typeof item === 'object' &&
        item !== null &&
        'is_saved_product' in item &&
        typeof (item as any).is_saved_product === 'boolean',
    )
  );
}

/**
 * 상품 목록에서 찜 상태 Record를 생성합니다.
 */
export function createLikeStatusRecord<T extends ProductWithSavedStatus>(
  ids: string[],
  data: T[],
): Record<string, boolean> {
  const likeStatus: Record<string, boolean> = {};
  ids.forEach((id, index) => {
    const item = data[index];
    likeStatus[id] = item?.is_saved_product ?? false;
  });
  return likeStatus;
}

/**
 * 배열이 변경되었는지 확인합니다.
 */
export function hasArrayChanged(current: string[], previous: string[]): boolean {
  return current.join() !== previous.join();
}
